import React from "react";
import { Outlet } from "react-router-dom";
import ToasterWrapper from "../../components/ToasterWrapper";

const PublicRouteLayout: React.FC = () => (
  <>
    <Outlet />
    <ToasterWrapper />
  </>
);

export default PublicRouteLayout;
